module["exports"] = [
  "Абаџиев",
  "Аврамов",
  "Аврамовски",
  "Аврамчев",
  "Ајановски",
  "Алексиев",
  "Алексов",
  "Алексовски",
  "Ангеловски",
  "Андов",
  "Андонов",
  "Андоновски",
  "Андреевски",
  "Антонов",
  "Анчевски",
  "Апостолов",
  "Апостолски",
  "Арсов",
  "Арсовски",
  "Атанасов",
  "Атанасовски",
  "Атков",
  "Ацев",
  "Ацевски",
  "Аџимитревски",
  "Бабамовски",
  "Бабунски",
  "Бавтировски",
  "Бајалски",
  "Бакевски",
  "Балабанов",
  "Басаровски",
  "Бачовски",
  "Беличанец",
  "Белковски",
  "Беловски",
  "Белогаски",
  "Белчев",
  "Бендевски",
  "Билбиловски",
  "Билјановски",
  "Бислимовски",
  "Битовски",
  "Блажевски",
  "Близнаков",
  "Богданов",
  "Богдановски",
  "Богдански",
  "Богоев",
  "Богоески",
  "Божиков",
  "Божинов",
  "Божиновски",
  "Бојановски",
  "Бојаџи",
  "Бојаџиев",
  "Боцевски",
  "Бошевски",
  "Бошков",
  "Бошковски",
  "Брезоски",
  "Бубуловски",
  "Бужаровски",
  "Бузев",
  "Бујуклиев",
  "Бунев",
  "Варсаковски",
  "Василевски",
  "Василески",
  "Васков",
  "Величковски",
  "Велјанов",
  "Велков",
  "Висулчев",
  "Владимирски",
  "Владов",
  "Влахов",
  "Влахчев",
  "Вражалски",
  "Гаврилски",
  "Гајдов",
  "Галевски",
  "Гапо",
  "Гаревски",
  "Генов",
  "Георгиев",
  "Георгиевски",
  "Герасимовски",
  "Гермов",
  "Геров",
  "Гечевски",
  "Гешоски",
  "Гигов",
  "Гиевски",
  "Главаш",
  "Глигоров",
  "Глигоровски",
  "Голабовски",
  "Грабул",
  "Грабулоски",
  "Грозданов",
  "Грошев",
  "Грујовски",
  "Групче",
  "Гугувчевски",
  "Гучев",
  "Давидовски",
  "Давков",
  "Давчев",
  "Давчевски",
  "Дамески",
  "Дамовски",
  "Дворчанец",
  "Дејанов",
  "Демниев",
  "Деспотовски",
  "Дилев",
  "Димитриев",
  "Димитров",
  "Димковски",
  "Димов",
  "Димовски",
  "Динев",
  "Диневски",
  "Дирјан",
  "Добревски",
  "Доброхотов",
  "Додевски",
  "Дојчинов",
  "Доневски",
  "Дракул",
  "Дренков",
  "Дрнков",
  "Дуганов",
  "Дуковски",
  "Ѓаконовски",
  "Ѓелев",
  "Ѓорѓевски",
  "Ѓорчев",
  "Ѓузелев",
  "Ѓурлуков",
  "Ѓурчинов",
  "Евремов",
  "Едиповски",
  "Ежов",
  "Ефтимов",
  "Жеков",
  "Железаров",
  "Жерновски",
  "Забазноски",
  "Зафировски",
  "Здравев",
  "Здравковски",
  "Зографски",
  "Иванов",
  "Ивановски",
  "Иваноски",
  "Игновски",
  "Игњатовски",
  "Икономов",
  "Илиев",
  "Илиевски",
  "Иљоски",
  "Исаковски",
  "Ицев",
  "Јакимовски",
  "Јаконов",
  "Јаневски",
  "Јанчевски",
  "Јачев",
  "Јованов",
  "Јовановски",
  "Јовчевски",
  "Јорданов",
  "Јордановски",
  "Јосифовски",
  "Јосифоски",
  "Јуруков",
  "Јурукоски",
  "Калајџиски",
  "Калчевски",
  "Камберски",
  "Кантарџиев",
  "Караѓозов",
  "Карадак",
  "Караман",
  "Каранфиловски",
  "Карев",
  "Каров",
  "Каровски",
  "Картов",
  "Катарџиев",
  "Кепески",
  "Керамитчиев",
  "Керамичиев",
  "Кирјазовски",
  "Киселинов",
  "Китаноски",
  "Кичевски",
  "Кљусев",
  "Кодра",
  "Колишевски",
  "Колозов",
  "Кондов",
  "Кондовски",
  "Конески",
  "Константинов",
  "Константиновски",
  "Кордалов",
  "Корубин",
  "Костадинов",
  "Костовски",
  "Котевски",
  "Котески",
  "Коцаре",
  "Коцо",
  "Кочовски",
  "Коџоман",
  "Крле",
  "Крстев",
  "Крстевски",
  "Крстески",
  "Крцковски",
  "Кузмановски",
  "Кулишев",
  "Куновски",
  "Куноски",
  "Кушевски",
  "Ладински",
  "Лазаревски",
  "Лазаров",
  "Лазески",
  "Лазовски",
  "Лакински",
  "Лактински",
  "Лапе",
  "Лахтов",
  "Левенски",
  "Лековски",
  "Леов",
  "Лечевски",
  "Липов",
  "Личеноски",
  "Лозановски",
  "Луловски",
  "Љутков",
  "Мазев",
  "Мајсторов",
  "Македонски",
  "Малевски",
  "Малески",
  "Маловски",
  "Манаковски",
  "Мангов",
  "Манговски",
  "Манев",
  "Маневски",
  "Манивилов",
  "Манчев",
  "Манчевски",
  "Маринов",
  "Марковски",
  "Мартиновски",
  "Мартиноски",
  "Масин",
  "Матевски",
  "Матковски",
  "Матовски",
  "Маџиров",
  "Миладинов",
  "Милосавлев",
  "Милошевски",
  "Милчин",
  "Миљовски",
  "Минчев",
  "Миовски",
  "Миронски",
  "Мисирков",
  "Митевски",
  "Митревски",
  "Митриќески",
  "Михајлов",
  "Михајловски",
  "Мицев",
  "Мицевски",
  "Мицковски",
  "Мицов",
  "Мишковски",
  "Младенов",
  "Младеновски",
  "Мојсовски",
  "Мокров",
  "Момировски",
  "Мошин",
  "Мукаетов",
  "Муратовски",
  "Мусалевски",
  "Мустачки",
  "Најденов",
  "Најдовски",
  "Најчески",
  "Наков",
  "Наневски",
  "Настев",
  "Наумов",
  "Наумовски",
  "Наумчески",
  "Начев",
  "Неделковски",
  "Нестор",
  "Несторовски",
  "Нетков",
  "Нешковски",
  "Николески",
  "Николов",
  "Николовски",
  "Никушев",
  "Нинов",
  "Оровчанец",
  "Ортаков",
  "Османли",
  "Павловски",
  "Павлоски",
  "Пајтонџиев",
  "Паковски",
  "Паликрушев",
  "Панговски",
  "Пандески",
  "Пандилов",
  "Пандовски",
  "Панков",
  "Панов",
  "Пановски",
  "Панчевски",
  "Папрадишки",
  "Пејов",
  "Пендовски",
  "Пенушлиски",
  "Пепељуговски",
  "Перински",
  "Перчинковски",
  "Петковски",
  "Петров",
  "Петровски",
  "Петрушев",
  "Петрушевски",
  "Пиперковски",
  "Планински",
  "Подгорец",
  "Полежиноски",
  "Полјански",
  "Попов",
  "Поповски",
  "Попоски",
  "Преспански",
  "Прилепчански",
  "Прличко",
  "Псалтиров",
  "Пуцков",
  "Равановски",
  "Радически",
  "Раковски",
  "Рацин",
  "Ризов",
  "Ристов",
  "Ристовски",
  "Ристоски",
  "Руменов",
  "Русјаков",
  "Русоманов",
  "Салџиев",
  "Санев",
  "Сариевски",
  "Светиев",
  "Серафимов",
  "Серафимовски",
  "Сидовски",
  "Силјановски",
  "Симов",
  "Симовски",
  "Симоновски",
  "Скаловски",
  "Славенски",
  "Славески",
  "Сланев",
  "Смаќоски",
  "Смилевски",
  "Смокварски",
  "Соколов",
  "Солев",
  "Солунски",
  "Софрониевски",
  "Спасеновски",
  "Спасов",
  "Спасовски",
  "Спиров",
  "Спировски",
  "Ставрев",
  "Ставрески",
  "Стаматоски",
  "Станков",
  "Станковски",
  "Старделов",
  "Стеванов",
  "Стевковски",
  "Стефанов",
  "Стефановски",
  "Стојанов",
  "Стојановски",
  "Стојаноски",
  "Стојков",
  "Стојковски",
  "Стојменски",
  "Стојчев",
  "Такев",
  "Таковски",
  "Талевски",
  "Талески",
  "Темелкоски",
  "Теодосиевски",
  "Терзиев",
  "Тодоров",
  "Тодоровски",
  "Тозија",
  "Толевски",
  "Томовски",
  "Тофоски",
  "Точко",
  "Тошев",
  "Тошевски",
  "Трајковски",
  "Тренески",
  "Тренчевски",
  "Трифуновски",
  "Тројачанец",
  "Трпеновски",
  "Тушевски",
  "Ќамилов",
  "Ќорнаков",
  "Ќортошев",
  "Ќурчиев",
  "Угриновски",
  "Узунов",
  "Узуновски",
  "Урдин",
  "Филиповски",
  "Фирфов",
  "Фотев",
  "Хаџиманов",
  "Хаџиниколов",
  "Христов",
  "Христовски",
  "Цанев",
  "Цветановски",
  "Цеков",
  "Цековски",
  "Ценев",
  "Црвенковски",
  "Црвенов",
  "Чакар",
  "Чакмаков",
  "Чаловски",
  "Чапаровски",
  "Чаушев",
  "Чашуле",
  "Чевревски",
  "Чејковски",
  "Чемерски",
  "Чемков",
  "Чипан",
  "Чокревски",
  "Чундев",
  "Чупона",
  "Чучков",
  "Чушкаров",
  "Џамбаз",
  "Џамбазов",
  "Џаџев",
  "Џеков",
  "Џинлески",
  "Џорлев",
  "Џувалековски",
  "Џунов",
  "Шаревски",
  "Шијак",
  "Шијаков",
  "Шијаковски",
  "Ширилов",
  "Шишков",
  "Шопов",
  "Шоптрајанов",
  "Штерјоски",
  "Шулинчевски"
];
